import { isTopEntity } from 'astra-core'
import { selectTopTagId } from 'astra-core/containers/CommonDataProvider'
import { EFeatureFlags } from 'astra-core/containers/ConfigProvider'
import { Tournament } from 'betweb-openapi-axios'

import { useAppFeatureFlag } from 'shared/config'
import { useAppSelector } from 'store'

export const useIsTopTournament = (tournament: Tournament): boolean => {
  const isEntityTagsEnabled = useAppFeatureFlag(
    EFeatureFlags.ENTITY_TAGS_ENABLED
  )
  const topTagId = useAppSelector(selectTopTagId)

  const isTopTournament = isEntityTagsEnabled
    ? isTopEntity(tournament, topTagId)
    : tournament.top

  return isTopTournament
}
